package music.jammers.client.shared.auth.di

import music.jammers.client.shared.analytics.auth.AuthAnalytics
import music.jammers.client.shared.analytics.auth.AuthAnalyticsImpl
import music.jammers.client.shared.auth.data.repository.AuthRepositoryImpl
import music.jammers.client.shared.auth.data.repository.TokenRepositoryImpl
import music.jammers.client.shared.auth.domain.repository.AuthRepository
import music.jammers.client.shared.auth.domain.repository.TokenRepository
import music.jammers.client.shared.auth.domain.usecase.LoginUseCase
import music.jammers.client.shared.auth.domain.usecase.LogoutUseCase
import music.jammers.client.shared.auth.presentation.viewmodel.LoginViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val authSharedModule = module {

    factory<LoginViewModel> {
        LoginViewModel(
            loginUseCase = get(),
            getCurrentUserUseCase = get(),
            analytics = get(),
            router = get(),
        )
    }

    single<AuthAnalytics> {
        AuthAnalyticsImpl(
            firebaseAnalytics = get(),
        )
    }

    single<LoginUseCase> {
        LoginUseCase(
            tokenRepository = get(),
            userRepository = get(),
            authRepository = get()
        )
    }

    single<LogoutUseCase> {
        LogoutUseCase(
            authRepository = get(),
            userRepository = get(),
            tokenRepository = get(),
        )
    }

    single<TokenRepository> {
        TokenRepositoryImpl(
            settings = get(),
        )
    }

    single<AuthRepository> {
        AuthRepositoryImpl(
            client = get(),
        )
    }
}

object LoginComponent : KoinComponent {

    val viewModel: LoginViewModel
        get() = getKoin().get<LoginViewModel>()
}